import { DOCUMENT_CATEGORIES } from '../types';
import type { DocumentCategory } from '../types';

/**
 * Which document kinds each section can actually USE (Christian's walk of deploy #20). The bank screens turn a bank or
 * credit-card statement into a Xero file, and that is all they can do with a document, so they offer that one kind.
 * A DR-15 return, a POS report and a payroll report are JOURNAL sources: they are uploaded from inside the journal
 * (`JournalSourcePicker`). The client's Documents tab is the document list, so it shows every kind.
 *
 * <p>A credit-card statement is the same kind as a bank statement: the same CSV shape (date, description, a signed
 * amount or a debit/credit pair) and the same Xero statement import, into the card's account.</p>
 */
export const STATEMENT_CATEGORIES: readonly DocumentCategory[] = ['bankStatement'];

/** What a journal built on each template is prepared from. A blank journal is how a payroll journal is typed. */
export const JOURNAL_SOURCE_FOR_TEMPLATE: Record<string, DocumentCategory> = {
  salesTaxDr15: 'dr15Return',
  posSalesPeriod: 'posReport',
  payrollRun: 'payrollReport',
  blank: 'payrollReport',
};

/**
 * A chart of accounts is IMPORTED from the G/L screen, which reads it (wave 5 §1). The Documents tab lists the kept files
 * but does not offer the kind for upload: a chart uploaded there would only be stored, never read.
 */
export const IMPORTED_ELSEWHERE: readonly DocumentCategory[] = ['chartOfAccounts'];

export function categoriesFor(mode: 'bankStatement' | 'accountTransactions' | 'library'): readonly DocumentCategory[] {
  return mode === 'library' ? DOCUMENT_CATEGORIES : STATEMENT_CATEGORIES;
}

/** The kinds a section's upload offers: its kinds, less those imported elsewhere. */
export function uploadKindsFor(mode: 'bankStatement' | 'accountTransactions' | 'library'): readonly DocumentCategory[] {
  return categoriesFor(mode).filter((c) => !IMPORTED_ELSEWHERE.includes(c));
}
